import { RadioImageComponent } from './radio-image.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RxTooltipModule } from '../tooltip/tooltip.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        RxTooltipModule,
        NgbTooltipModule
    ],
    declarations: [
        RadioImageComponent,
    ],
    exports: [
        RadioImageComponent
    ]
})
export class RxRadioImageModule { }
